export const LOADING_SHOW = "LOADING_SHOW";
export const LOADING_HIDE = "LOADING_HIDE";
export const LOADING_CONTENT_SHOW = "LOADING_CONTENT_SHOW";
export const LOADING_CONTENT_HIDE = "LOADING_CONTENT_HIDE";
